<template>
    <div class="wrapper">
        <span class="title">{{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.TITLE') }}</span>
        <input 
            type="text" 
            :placeholder="$t('CAMPAIGN_FLOW.SIDEBAR_SEARCH_FIELD.PLACEHOLDER')"
            v-model="searchQuery"
        >
        <ul class="list">
            <li 
                v-for="currentList in filteredListContacts" :key="currentList.id" 
                class="item"
                @click="openModalEdit(currentList)"
            >
                <div class="item-text">
                    <fluent-icon icon="people" size="16"/>
                    {{ currentList.name }}
                </div>
            </li>
        </ul>
        <modal-update-list-contacts
            v-if="modalEdit" 
            :show="modalEdit"
            :onClose="closeModalEdit"
            @submit="handleListContacts"
            :listContactSelected="selectList"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalUpdateListContacts from './ModalUpdateListContacts.vue';

export default {
    name: 'ContactsListSidebar',
    components: { ModalUpdateListContacts },
    data() {
        return {
            selectList: null,
            modalEdit: false,
            searchQuery: ''
        };
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
            currentUser: 'getCurrentUser',
            listContacts: 'campaignsContactList/getList'
        }),
        filteredListContacts() {
            return this.listContacts.filter(contact => 
                contact.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    methods: {
        openModalEdit(list) {
            this.selectList = list;
            this.modalEdit = true;
        },
        closeModalEdit() {
            this.modalEdit = false;
        },

        handleListContacts(payload){
            const newList = {
                campaign_contact_list: {
                    ...payload,
                    account_id: this.accountId
                }
            }

            this.$store.dispatch('campaignsContactList/update', newList)
            .then(() => {
                this.showAlert(this.$t('CAMPAIGN_FLOW.LIST_CONTACTS.EDIT.API.SUCCESS_MESSAGE'));
                this.closeModalEdit();
            });
        },
        showAlert(message) {
            bus.$emit('newToastMessage', message);
        },
    }
};
</script>

<style scoped>
.wrapper {
    padding: 8px;
}

.title {
    color: var(--s-700);
    display: flex;
    font-weight: var(--font-weight-bold);
    line-height: var(--space-normal);
    margin: var(--space-small) 0;
    padding: 0 var(--space-small);
    font-size: var(--font-size-small);
}

input {
    margin: 0 0 0 8px;
    height: 3rem;
    width: calc(100% - 16px);
    padding: 8px;
    border: 1px solid var(--s-400);
    border-radius: 4px;
}

.item-text {
    display: inline-flex;
    color: var(--s-600);
    font-weight: var(--font-weight-medium);
    width: 100%;
    height: var(--space-medium);
    padding: var(--space-smaller) var(--space-smaller);
    margin: var(--space-smaller) 0;
    text-align: left;
    line-height: 1.2;
    font-size: 14px;
    gap: 0.3rem;
}
.item-text:hover {
    color: var(--g-20) ;
}

.item {
    cursor: pointer;
}
</style>
